import { useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { TOGGLE_MODE } from "../../redux/actions/constants";
import DarkLightMode from "../common-components/DarkLightMode";

const HamburgerMenu = () => {
    const isDarkMode = useSelector((state) => state.persistedReducer.isDarkMode);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const menubarItems = [
        {
            itemName: "Homepage",
            icon: "/icons/homepage.png",
            path: "/"
        },
        // { itemName: "Trade", icon: "/icons/stock.png", path: "/trade" },
        {
            itemName: "Charts",
            icon: "/icons/line-chart.png",
            path: "/charts"
        },
        {
            itemName: "Programs Status",
            icon: "/icons/switch.png",
            path: "/programs-status"
        },
        {
            itemName: "settings",
            icon: "/icons/settings-light.png",
            path: "/settings"
        },

        {
            itemName: "Dashboard",
            icon: "/icons/dashboard.png",
            path: "/dashboard"
        },
        {
            itemName: "Profile",
            icon: "/icons/profile.png",
            path: "/profile"
        },
        {
            itemName: "Log out",
            icon: "/icons/log-out.png",
            path: "/logout"
        }
    ];
    return (
        <div
            style={{
                zIndex: 5000
            }}
            className={`flex-1 relative flex min-h-13 justify-start items-center sm:hidden   ${
                isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
            } `}>
            <div>
                <img
                    onClick={() => setShowMenu(!showMenu)}
                    src="/icons/menu.png"
                    alt="menu"
                    className={`max-w-8 ml-3 cursor-pointer ${showMenu ? "rotate-90" : "rotate-0"}`}
                />
            </div>
            <ul
                className={`flex-1  ${
                    showMenu ? "flex" : "hidden"
                } flex-col absolute top-14 w-full last:border-b-1  ${
                    isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                } `}>
                {menubarItems.map((mb, index) => {
                    const { itemName, icon, path } = mb;
                    return (
                        <li
                            key={index}
                            className="flex flex-col border-t-1 py-2 justify-center items-center list-none text-center sm:mt-4 w-full cursor-pointer">
                            <img
                                className=" w-6"
                                src={icon}
                                alt=""
                                onClick={() => {
                                    setShowMenu((prev) => {
                                        navigate(path);
                                        return !prev;
                                    });
                                }}
                            />
                            <h6 className="text-vsm">{itemName}</h6>
                        </li>
                    );
                })}
                <div className=" border-t-1 flex justify-center items-center">
                    <DarkLightMode
                        img={{
                            className: " py-2 max-w-10 cursor-pointer",
                            src: `/icons/${isDarkMode ? "night.png" : "light.png"}`
                        }}
                        toggleMode={() =>
                            setShowMenu((prev) => {
                                dispatch({ type: TOGGLE_MODE });
                                return false;
                            })
                        }
                    />
                </div>
            </ul>
        </div>
    );
};

export default HamburgerMenu;
